import React, { PropsWithRef, forwardRef } from 'react';
import { InputNumberProps } from './types';
import { Input as JuicyInput } from '@vtbhome/juicyfront';
import { StyledFormGroup } from './input-number.styles';
import { ErrorMessageInput } from '../error-message-input/error-message-input';

export const InputNumber = forwardRef(
    (
        { error, label, hint, maxLength, emptyValue = 0, onChange, onBlur, ...props }: PropsWithRef<InputNumberProps>,
        ref: React.Ref<HTMLLabelElement | null>
    ) => {
        const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
            const target = e.target as HTMLInputElement;
            const isExceeded = maxLength !== undefined && target.value.length > maxLength;
            if (!isExceeded && onChange) {
                onChange(e);
            }
        };

        const handleBlur = (e: React.FocusEvent<HTMLInputElement, Element>) => {
            if (props.value === '' && emptyValue !== undefined && onChange) {
                const newEvent = { ...e, target: { ...e.target, value: String(emptyValue) } };
                onChange(newEvent);
            }
            if (onBlur) {
                onBlur(e);
            }
        };

        return (
            <StyledFormGroup
                required={props.required}
                $error={error}
                label={label}
                errorMessage={<ErrorMessageInput error={error} hint={hint} />}>
                <JuicyInput
                    type='number'
                    ref={ref}
                    invalid={Boolean(error)}
                    controls={false}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    {...props}
                />
            </StyledFormGroup>
        );
    }
);

InputNumber.displayName = 'InputText';
